import React, { useState, useContext, useRef, useEffect} from "react";

import { View,  Text, Alert, TouchableOpacity}  from 'react-native';

import {useNavigation} from '@react-navigation/native'

import {estilos} from '../util/estilos'

import * as util from '../util/util'

import {buscarItem as wsBuscarItem, alterarItem as wsAlterarItem} from '../ws/ws_itens'

import {buscarImagensItens, buscarImagemItem} from '../ws/ws_imagens_itens'

import contexto from '../util/contexto'

import Botao from '../componentes/Botao'

import { ViewDegradeVertical} from '../componentes/ViewDegradeVertical';

import { useFocusEffect } from '@react-navigation/native';

import {Camera} from 'expo-camera'

import {ITEM_TIPO_PRODUTO, TIPO_CAMERA_ITEM, MSG_ERRO_PADRAO, TELA_DETALHE_ITEM, DNC_TIPO_RELACAO_ITEM} from '../util/constantes'

import {TELA_PRINCIPAL, LARGURA_AREA_CONTEUDO_PX, TELA_NOVA_DENUNCIA} from '../util/constantes'

import {carregamento} from '../componentes/Carregamento'

import { BackHandler } from 'react-native';

import FormularioItem from '../componentes/FormularioItem'
	
import * as numeros from '../util/numeros'

import {buscar_loja} from '../ws/ws_usuarios'

import Scroll from '../componentes/Scroll'

import Imagem from '../componentes/Imagem'

import Bloco from '../componentes/Bloco'

import InfosLoja from '../componentes/InfosLoja'





export default function TelaDetalheItem(){
   
	const {valorContexto, setValorContexto} = useContext(contexto);

	const [sincronizando, setSincronizando] = useState(true)  

	const [listaImagens, setListaImagens] = useState([])
	
	const [imagemAtual, setImagemAtual] = useState(null)

    const navegacao = new useNavigation();
	
	const [editando, setEditando] = useState(false)
    
	const [item, setItem] = useState(null)
	
	const formularioItemRef  = useRef(null)
	
	const [modoEdicao, setModoEdicao] = useState(false)
	
	const [loja, setLoja] = useState(null) 
	
	const blockBackRef = useRef(false);

	const [sincronizandoImagem, setSincronizandoImagem] = useState(false)  


	const voltar = () => {
			
		if(blockBackRef.current == true){
			
			util.print("voltar editando");
			
			setEditando(false);
			
			blockBackRef.current = false;
		}
		else
			navegacao.replace(util.processaVoltar())
		
		return true;
	};


	useFocusEffect(React.useCallback(() => {
		
		console.log('TelaDetalheItem');
		
		BackHandler.addEventListener('hardwareBackPress', voltar);

		buscarDados();

		return () => {
		  BackHandler.removeEventListener('hardwareBackPress', voltar);
		};
		
	}, []));
	

	const buscarDados= async ()=>{
	
		util.print("buscarDados");


		setSincronizando(true);
		
		let aux  = await wsBuscarItem(valorContexto.idItem);
   
		if(util.temConteudo(aux)){
			
			setItem(aux);
			
			setModoEdicao(aux.fk_usuario == valorContexto.idUsuarioAtual)
		
			let itens  = await buscarImagensItens(valorContexto.idItem);
		
			if(util.temConteudo(itens)){

				let lista = []	

				itens.forEach(item => {
					lista.push({
						id: item.id,
						menor: item.imagem,
						maior: null
					})
				});

				lista[0].maior = await buscarImagemMaior(lista[0].id);

				setImagemAtual(lista[0].maior);

				setListaImagens(lista);
			}
			else
				setListaImagens([]);

			setLoja( await buscar_loja(aux.fk_usuario))
		}
		
		setSincronizando(false);
	}
	

	const buscarImagemMaior = async (id)=>{

		let imagem = await buscarImagemItem(id)
			
		return imagem!=null && imagem.imagem!=null?imagem.imagem:null;
	}
	

	const verImagem = async (item)=>{

		util.print(item.id);

		if(item.maior!=null){
			setImagemAtual(item.maior);
		}
		else{

			setSincronizandoImagem(true);

			const lista = [...listaImagens];

			let maior = await buscarImagemMaior(item.id)

			lista.map(async (aux) => {

				if(aux.id == item.id){
					aux.maior= maior;
					setImagemAtual(maior);
				}
			});

			setListaImagens(lista);

			setSincronizandoImagem(false);
		}
	}


	const prepararFormulario= async ()=>{
	
		util.print("prepararFormulario");

		if(editando && item!=null && formularioItemRef.current)
			formularioItemRef.current.setDados(item, listaImagens);
		
	}
	
	
	useEffect(() => {prepararFormulario()}, [editando]);
	
	
    async function salvar(dados){
		
		dados['id_item'] = item.id;
		
        if(await wsAlterarItem(dados) ==null){
                
            formularioItemRef.current.salvarErro(MSG_ERRO_PADRAO);
            return;
        }

		formularioItemRef.current.salvarSucesso();
	   
		blockBackRef.current = false;

		setEditando(false);
		
		await buscarDados();
    }


	const excluirFoto= async (idItemRemovido)=>{

		let lista = [];

		listaImagens.map(async (aux) => {

			if(aux.id != idItemRemovido)
				lista.push(aux)	
		});
		
		if(util.temConteudo(lista)){

			if(lista[0].maior==null)
				lista[0].maior = await buscarImagemMaior(lista[0].id);

			setImagemAtual(lista[0].maior);
		}
		else
			setImagemAtual(null);

		setListaImagens(lista);
	}
	
    return (
		<ViewDegradeVertical titulo="Detalhe Produto/Serviço" voltar={()=>voltar()}>  
			{ (sincronizando) ?
				(carregamento(sincronizando)):
				(<Scroll> 
					{(editando)?
						(<FormularioItem 
							ref={formularioItemRef} 
							salvar={salvar} 
							excluirFoto={excluirFoto}
							recarregar={async()=>{
								
								setEditando(false);
								await buscarDados();
								setEditando(true);
							}}/>):
					(formularioVisualizar())
					}
				</Scroll>)	
			} 
        </ViewDegradeVertical>
	)
	
	
	function formularioVisualizar(){
		return(
			<View>
				<Bloco>  
					<View style={{marginTop:10}}/>  
					<View style={{alignItems:'center'}}>
						
						<Text style={estilos.rotulo_titulo}>{item.nome}</Text>	    

						<View style={{marginTop:20}}/>   
					
						{sincronizandoImagem?
							(carregamento(sincronizandoImagem)):
							(<View style={{alignItems:'center'}}>

								<Imagem imagem={imagemAtual} tamanho={LARGURA_AREA_CONTEUDO_PX-200}/>
								
								{listaImagens.length>0?
									(<View style={[estilos.grade, {alignItems:'center'}]}>
										{listaImagens.map((item, index) => 
											<TouchableOpacity key={index} onPress={()=>verImagem(item)}>
												<Imagem imagem={item.menor} tamanho={60} style={{margin:5}}/>
											</TouchableOpacity>)
										}					
									</View>):
									(<Text style={estilos.rotulo_menor}>{modoEdicao?"Você ainda nao envio nenhuma foto":""}</Text>)
								}
							</View>)
						}
					</View>	
					
					<View style={{marginTop:20}}/>  

					<View style={estilos.grade}>
						<Text style={estilos.rotulo_titulo}>Tipo: </Text>
						<Text style={[estilos.coluna, estilos.rotulo_padrao]}>{item.tipo==ITEM_TIPO_PRODUTO?'Produto':'Serviço'}</Text>
					</View>
					
					<View style={{marginTop:10}}/> 

					<Text style={estilos.rotulo_titulo}>Descrição:</Text>
					
					<View style={{marginTop:10}}/> 
					
					<Text style={estilos.rotulo_padrao}>{item.descricao}</Text>
					
					<View style={{marginTop:10}}/> 

					<Text style={estilos.rotulo_titulo}>Palavras-chaves:</Text>
					
					<View style={{marginTop:10}}/> 
					
					<Text style={estilos.rotulo_padrao}>{item.tags}</Text>
				
					<View style={{marginTop:10}}/> 

					<View style={estilos.grade}>
						<View style={estilos.coluna}> 
							<Text style={estilos.rotulo_titulo}>Categoria:</Text>
						</View>
						<View style={estilos.coluna_dupla}> 
							<Text style={estilos.rotulo_padrao}>{item.nome_categoria}{util.temConteudo(item.nome_subcategoria)?"/"+item.nome_subcategoria:""}</Text>
						</View>
					</View>

					<View style={{marginTop:10}}/> 

					<View style={estilos.grade}>
						<Text style={estilos.rotulo_titulo}>Preço (R$): </Text>
						<Text style={[estilos.coluna, estilos.rotulo_padrao]}>{numeros.formataNumeroParaMostrar(item.valor)}</Text>
					</View>

					<View style={{marginTop:10}}/> 
					
					<View style={estilos.grade}>
						<Text style={estilos.rotulo_titulo}>Marca/Fabricante: </Text>
						<Text style={[estilos.coluna, estilos.rotulo_padrao]}>{item.marca}</Text>
					</View>

					<View style={{marginTop:10}}/> 

					<View style={estilos.grade}>
						<Text style={estilos.rotulo_titulo}>Modelo: </Text>
						<Text style={[estilos.coluna, estilos.rotulo_padrao]}>{item.modelo}</Text>
					</View>		

					<View style={{marginTop:10}}/> 

					<View style={estilos.grade}>
						<Text style={estilos.rotulo_titulo}>Cor: </Text>
						<Text style={[estilos.coluna, estilos.rotulo_padrao]}>{item.cor}</Text>
					</View>		

					<View style={{marginTop:10}}/> 

					<View style={estilos.grade}>
						<Text style={estilos.rotulo_titulo}>Tamanho/Dimensões: </Text>
						<Text style={[estilos.coluna, estilos.rotulo_padrao]}>{item.tamanho}</Text>
					</View>	

					{modoEdicao && 
						<View style={{alignItems:'center'}}>
							<View style={{marginTop:30}}/>
							<Botao 
								acao={()=>{
									
									blockBackRef.current = true

									setEditando(true)
								}}
								texto={"Editar "+(item.tipo==ITEM_TIPO_PRODUTO?"Produto":"Serviço")}/>    
						</View>
					}
					<View style={{marginTop:10}}/>  
				</Bloco> 	
				
				<InfosLoja loja={loja} titulo="Anunciado por" detalhado={true} voltarPara={TELA_DETALHE_ITEM}/>
			
				<Bloco>  
					<View style={{marginTop:10}}/> 
					<View style={{alignItems:'center'}}>	
						<Botao 
							acao={()=>{
								
								setValorContexto(prevState =>({...prevState, tipoDenuncia: DNC_TIPO_RELACAO_ITEM}));

								setValorContexto(prevState =>({...prevState, idRelacaoDenuncia: valorContexto.idItem}));

								navegacao.replace(TELA_NOVA_DENUNCIA)
							}}
							somente_texto={true}
							texto="Denunciar Anúncio"/>   
					</View>
					<View style={{marginTop:10}}/> 
				</Bloco> 	
			</View> 
		)
	}
	
}